import { useState, useEffect } from 'react';
import '../styles/Modal.css';
import { supportedTranslationLanguages } from '../constants/letureLanguages';

// 언어 설정 모달 컴포넌트
const InputLanguageSettingsModal = ({
    isOpen,
    onClose,
    inputLanguage,
    onSave,
}: {
    isOpen: boolean;
    onClose: () => void;
    inputLanguage: string;
    onSave: (language: string) => void;
}) => {
    const [selectedLanguage, setSelectedLanguage] = useState<string>('');

    // 모달 스크롤 방지 효과
    useEffect(() => {
        if (isOpen) {
            // 스크롤 위치 저장
            const scrollY = window.scrollY;

            // body에 modal-open 클래스 추가
            document.body.classList.add('modal-open');

            // 스크롤 위치 설정
            document.body.style.top = `-${scrollY}px`;

            // 정리 함수
            return () => {
                document.body.classList.remove('modal-open');
                document.body.style.top = '';
                window.scrollTo(0, scrollY);
            };
        }
    }, [isOpen]);

    // 모달이 열릴 때마다 언어 설정 초기화
    useEffect(() => {
        if (isOpen) {
            setSelectedLanguage(inputLanguage || '');
        }
    }, [isOpen, inputLanguage]);

    if (!isOpen) return null;

    const handleSave = () => {
        onSave(selectedLanguage);
        onClose();
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-container" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>입력 언어 설정</h3>
                    <button className="modal-close-btn" onClick={onClose}>
                        ×
                    </button>
                </div>
                <div className="modal-body">
                    <div className="settings-content">
                        <p>입력 언어를 선택해주세요 (하나만 선택 가능)</p>
                        <div className="language-checkboxes">
                            {supportedTranslationLanguages
                                .filter(lang => lang.code !== 'ko-KR')
                                .map(lang => (
                                    <label key={lang.code} className="language-checkbox">
                                        <input
                                            type="checkbox"
                                            value={lang.code}
                                            checked={selectedLanguage === lang.code}
                                            onChange={() => setSelectedLanguage(lang.code)}
                                        />
                                        <span>
                                            {lang.koreanName} ({lang.nativeName})
                                        </span>
                                    </label>
                                ))}
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="btn-cancel" onClick={onClose}>
                        취소
                    </button>
                    <button className="btn-primary" onClick={handleSave}>
                        저장
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InputLanguageSettingsModal;
